<template>
  <div class="mx-auto max-w-lg space-y-4">
    <p class="text-center font-semibold">
      {{ $t('share_link_everywhere') }}
    </p>
    <input
      type="text"
      :value="landingPageUrl"
      class="w-full rounded-md border px-4 py-3"
      readonly
    />
    <ShareCopyButton
      :source="landingPageUrl"
      :label="$t('copy_link_to_content_experience')"
      full-width
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  landingPageUrl: string
}>()
</script>
